import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="space-y-5">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-water-flash-line text-background-50 text-lg" />
              </div>
              <span className="font-heading font-bold text-xl text-background-50 tracking-wide">
                51扒瓜网
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 max-w-xs">
              全天候追踪娱乐圈最新八卦和网络热点，独家挖掘大瓜猛料，吃瓜内容每日不断更新，是娱乐八卦爱好者的集中地。
            </p>
            <div className="flex items-center gap-3">
              <a
                href="http://rkldzswyxgs.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-300 hover:text-primary-400 hover:border-primary-400 transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-base" />
              </a>
              <a
                href="http://rkldzswyxgs.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-300 hover:text-primary-400 hover:border-primary-400 transition-colors"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-base" />
              </a>
              <a
                href="http://rkldzswyxgs.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-300 hover:text-primary-400 hover:border-primary-400 transition-colors"
                aria-label="抖音"
              >
                <i className="ri-tiktok-line text-base" />
              </a>
              <a
                href="http://rkldzswyxgs.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 rounded-full border border-background-600 flex items-center justify-center text-background-300 hover:text-primary-400 hover:border-primary-400 transition-colors"
                aria-label="小红书"
              >
                <i className="ri-book-open-line text-base" />
              </a>
            </div>
          </div>

          {/* Categories Column */}
          <div className="space-y-5">
            <h4 className="font-heading font-semibold text-base text-background-50">
              热门分类
            </h4>
            <ul className="space-y-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-400 transition-colors inline-flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-xs" />
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors inline-flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-xs" />
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="space-y-5">
            <h4 className="font-heading font-semibold text-base text-background-50">
              联系我们
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-mail-line text-sm text-primary-400" />
                </div>
                <div>
                  <p className="text-xs text-background-500 uppercase tracking-wider mb-0.5">电子邮箱</p>
                  <p className="text-sm text-background-200">hello@rkldzswyxgs.com</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-sm text-primary-400" />
                </div>
                <div>
                  <p className="text-xs text-background-500 uppercase tracking-wider mb-0.5">办公地址</p>
                  <p className="text-sm text-background-200">北京市朝阳区建国路88号SOHO现代城</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-time-line text-sm text-primary-400" />
                </div>
                <div>
                  <p className="text-xs text-background-500 uppercase tracking-wider mb-0.5">更新时段</p>
                  <p className="text-sm text-background-200">每日早8点至凌晨2点持续更新</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-700/50">
        <div className="px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 51扒瓜网 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <Link to="/about" className="hover:text-background-300 transition-colors">关于我们</Link>
            <span className="text-background-700">|</span>
            <span className="hover:text-background-300 transition-colors cursor-pointer">隐私政策</span>
            <span className="text-background-700">|</span>
            <span className="hover:text-background-300 transition-colors cursor-pointer">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
